<app-dialog-template>
  <app-dialog-template-header>
    <app-dialog-template-title>Field path</app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>

  <app-dialog-template-body>
    <app-object-lookup
      [objectName]="ObjectNameEnum.BbsObject"
      [label]="'Object'"
      [isFullWide]="true"
      [formControl]="objectFormControl">
    </app-object-lookup>
    <ng-container *ngIf="objectFormControl.value">
      <app-field-path-input
        [initialObjectDefinition]="objectFormControl.value"
        [formControl]="fieldPathFormControl">
      </app-field-path-input>
      Path: <b>{{ fieldPathFormControl.value }}</b>
    </ng-container>
  </app-dialog-template-body>

  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1"
      [disabled]="!fieldPathFormControl.value"
      (clickEvent)="copy()">
      Copy
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
